$(function(){
	// function mediaResize() {
	// 	var media = $(".media")
	// 	media.each(function(){
	// 		var mediaWidth = $(this).width()
	// 		var mediaImg = $(this).find(".media-left img")
	// 		var mediaImgWidth = $(this).find(".media-left img").width()
	// 		var mediaBody = $(this).find(".media-body")
	// 		var ratio = mediaWidth*0.3333;

	// 		if (mediaImgWidth > ratio) {
	// 			// console.log("smaller")
	// 			mediaBody.addClass('media-body-full')
	// 		} else {
	// 			mediaBody.removeClass('media-body-full')
	// 		}
	// 	});
	// }

	// $(window).resize(function(){
	// 	mediaResize()
	// })

	// mediaResize()
	
});
